<template>
  <div cols="12" lg="6" md="6" sm="12" :align="mLoc">
    <v-app-bar color="#F5F7FA" elevation="0" height="88" class="hd-bar"
      :style="{ paddingLeft: headerLeftOffset + 'px' }">
      <!-- ซ้าย: คำทักทาย (แสดงเฉพาะหน้า Dashboard) -->
      <div v-if="showGreeting" class="hd-greeting-wrap">
        <h1 class="hd-greeting">
          {{ greetingText }},
          <span class="hd-name">{{ displayName }}</span>
        </h1>
        <div class="hd-subdate">{{ todayLongText }}</div>
      </div>

      <v-spacer></v-spacer>

      <!-- ขวา: เวลา / avatar / ชื่อ + แผนก -->
      <div class="hd-right">
        <span class="hd-time d-none d-sm-inline">
          Current time <b>{{ currentTime }}</b>
        </span>

        <v-menu bottom left min-width="200px" rounded offset-y>
          <template v-slot:activator="{ on, attrs }">
            <div class="hd-user" v-bind="attrs" v-on="on">
              <v-avatar size="42" color="#3E87BE">
                <img v-if="image_profile" :src="image_profile" class="hd-avatar-img" @error="image_profile = ''" />
                <span v-else class="white--text font-weight-medium">{{ user_text_profile || "U" }}</span>
              </v-avatar>

              <div class="hd-divider d-none d-md-block"></div>

              <div class="hd-user-text d-none d-md-block">
                <div class="hd-user-name">{{ displayName }}</div>
                <div class="hd-user-dept">{{ department_name }}</div>
              </div>

              <v-icon small color="#6B7280" class="ml-1">mdi-chevron-down</v-icon>
            </div>
          </template>
          <v-card>
            <v-list-item-content class="justify-start">
              <div class="mx-auto text-start">
                <v-divider class="mt-2"></v-divider>
                <v-btn depressed text block @click="resetPassword">
                  <v-icon small>mdi-account-settings-outline</v-icon>
                  My Profile
                </v-btn>
                <v-divider></v-divider>
                <v-btn depressed text block @click="onClickLogOff">
                  <v-icon small>mdi-export</v-icon>
                  logout
                </v-btn>
                <v-divider></v-divider>
              </div>
            </v-list-item-content>
          </v-card>
        </v-menu>
      </div>
    </v-app-bar>

    <v-speed-dial v-if="true" v-model="fab" bottom right fixed direction="top" transition="slide-y-reverse-transition">
      <template v-slot:activator>
        <v-btn v-model="fab" color="#0A7EA5" dark fab outlined small @click="openChat">
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-chat
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>
  </div>
</template>

<script>
import { server, imageUrl } from "@/services/constants";
import api from "@/services/api";

// หน้าที่จะแสดงคำทักทาย (Good morning, ...) ใน Header
// ปรับ path ให้ตรงกับ route ของหน้า Dashboard ในโปรเจกต์
const GREETING_ROUTES = ["/", "/dashboard"];

export default {
  name: "Header",
  data() {
    return {
      mLoc: "",
      mycompany: [],
      th_name: "",
      eng_name: "",
      department_name: "",
      image: "",
      image_profile: "",
      user_text_profile: "",
      fab: false, // Add this line to control the FAB
      currentTime: "",
      now: new Date(),
      clockTimer: null,
    };
  },
  async mounted() {
    // นาฬิกาใน Header
    this.tickClock();
    this.clockTimer = setInterval(this.tickClock, 1000);

    await this.getMyCompany();
    await this.loadEmpdata();
  },
  beforeDestroy() {
    if (this.clockTimer) {
      clearInterval(this.clockTimer);
      this.clockTimer = null;
    }
  },
  computed: {
    version() {
      return process.env.VUE_APP_VERSION;
    },
    title() {
      return process.env.VUE_APP_TITLE;
    },
    getENV() {
      return process.env.NODE_ENV;
    },
    // ใช้ชื่ออังกฤษก่อน ถ้าว่างใช้ชื่อไทย
    displayName() {
      const en = (this.eng_name || "").trim();
      return en ? en : this.th_name || "";
    },
    // เว้นที่ด้านซ้ายเท่าความกว้างเมนูด้านข้าง (navigation drawer) เพื่อไม่ให้บังข้อความ
    headerLeftOffset() {
      const drawer = (this.$vuetify && this.$vuetify.application && this.$vuetify.application.left) || 0;
      return drawer + 20;
    },
    showGreeting() {
      const path = (this.$route && this.$route.path) || "";
      return GREETING_ROUTES.includes(path);
    },
    greetingText() {
      const h = this.now.getHours();
      if (h < 12) return "Good morning";
      if (h < 18) return "Good afternoon";
      return "Good evening";
    },
    todayLongText() {
      return this.now.toLocaleDateString("en-GB", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    },
  },
  methods: {
    tickClock() {
      const now = new Date();
      this.now = now;
      const hours = now.getHours();
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const period = hours >= 12 ? "PM" : "AM";
      const h12 = hours % 12 === 0 ? 12 : hours % 12;
      this.currentTime = `${h12}:${minutes} ${period}`;
    },
    async loadEmpdata() {
      const res_emp = await api.getAccountByidMenu(
        localStorage.getItem(server.USER_ID)
      );
      // console.log(`loadEmpdata data: `, JSON.stringify(res_emp.data));

      this.th_name = res_emp.data[0].name;
      this.eng_name = res_emp.data[0].eng_name;
      this.department_name = res_emp.data[0].department_name;
      this.image = res_emp.data[0].image;

      this.user_text_profile = this.buildInitials();

      if (this.image != "" && this.image != null) {
        this.image_profile =
          imageUrl +
          "/" +
          // localStorage.getItem(server.USER_ID) +
          // "/" +
          this.image;
        localStorage.setItem(server.USER_IMAGE_URL, this.image_profile);
      } else {
        // 💡 1. ป้องกันกรณีชื่อ eng_name ส่งมาเป็นค่าว่าง หรือไม่มีค่า
        if (this.eng_name && this.eng_name.trim() !== "") {

          const nameParts = this.eng_name.trim().split(/\s+/); // ตัดคำด้วยช่องว่าง (รองรับการเคาะช่องว่างหลายที)
          const firstLetter = nameParts[0] ? nameParts[0].substring(0, 1) : "";

          // เช็คว่ามีนามสกุล หรือคำด้านหลังไหม (ไม่ว่าจะอยู่อินเด็กซ์ที่ 1 หรือ 2)
          // ถ้ามีให้เอาตัวแรกมาใช้ ถ้าไม่มีให้ใช้ค่าว่าง
          let lastLetter = "";
          if (nameParts.length > 1) {
            // ดึงคำสุดท้ายของอาร์เรย์มาทำอักษรย่อตัวหลัง (ปลอดภัยที่สุด ไม่ฟิกซ์อินเด็กซ์)
            lastLetter = nameParts[nameParts.length - 1].substring(0, 1);
          }

          this.user_text_profile = (firstLetter + lastLetter).toUpperCase();
        } else {
          // 💡 2. เคสที่ชื่ออังกฤษไม่มีจริง ๆ ให้ดึงจากชื่อไทย th_name มาแก้ขัดแทน หรือใส่ตัวย่อกลาง ๆ ไว้
          this.user_text_profile = this.th_name ? this.th_name.substring(0, 1) : "U";
        }

        localStorage.setItem(server.USER_IMAGE_URL, null);
      }
    },
    buildInitials() {
      if (this.eng_name && this.eng_name.trim() !== "") {
        const parts = this.eng_name.trim().split(/\s+/);
        const first = parts[0] ? parts[0].substring(0, 1) : "";
        const last = parts.length > 1 ? parts[parts.length - 1].substring(0, 1) : "";
        return (first + last).toUpperCase();
      }
      return this.th_name ? this.th_name.substring(0, 1) : "U";
    },
    async getMyCompany() {
      const result = await api.getCompanyByID(
        localStorage.getItem(server.COMPANYID)
      );
      this.mycompany = result.data;
    },
    onClickLogOff() {
      this.$store.state.navMenu = false;
      this.$store.dispatch("doLogout");
    },
    resetPassword() {
      // alert("Reset Password");
      this.$router.push("/my-profile");
    },

    openChat() {
      const dTimeData = {
        dtime_token: localStorage.getItem("dtime_token"),
        dtime_user_id: localStorage.getItem("dtime_user_id"),
        dtime_username: localStorage.getItem("dtime_username"),
        dtime_email: localStorage.getItem("dtime_email"),
        dtime_fullname: localStorage.getItem("dtime_fullname"),
        dtime_role: localStorage.getItem("dtime_role"),
        dtime_company_id: localStorage.getItem("dtime_company_id"),
        dtime_department_id: localStorage.getItem("dtime_department_id"),
        dtime_position_id: localStorage.getItem("dtime_position_id"),
        dtime_user_image_url: localStorage.getItem("dtime_user_image_url"),
        dtime_login_url: window.location.origin, // เพื่อให้กลับมาหา D-Time ได้
      };

      // สร้าง URL parameters
      const params = new URLSearchParams();
      Object.entries(dTimeData).forEach(([key, value]) => {
        if (value) {
          params.set(key, value); // ไม่ต้อง encodeURIComponent เพราะ URLSearchParams จัดการให้แล้ว
        }
      });

      // เปิด Chat ใน tab ใหม่หรือ popup
      const chatUrl = `https://chat-dev.dcm.co.th?${params.toString()}`;
      // const chatUrl = `http://localhost:3000?${params.toString()}`;
      window.open(chatUrl, "chat", "width=1200,height=800");
    },

    openChat_V2() {
      const dTimeData = {
        dtime_token: localStorage.getItem("dtime_token"),
        dtime_user_id: localStorage.getItem("dtime_user_id"),
        dtime_username: localStorage.getItem("dtime_username"),
        dtime_email: localStorage.getItem("dtime_email"),
        dtime_fullname: localStorage.getItem("dtime_fullname"),
        dtime_role: localStorage.getItem("dtime_role"),
        dtime_company_id: localStorage.getItem("dtime_company_id"),
        dtime_department_id: localStorage.getItem("dtime_department_id"),
        dtime_position_id: localStorage.getItem("dtime_position_id"),
        dtime_user_image_url: localStorage.getItem("dtime_user_image_url"),
        dtime_login_url: window.location.origin, // เพื่อให้กลับมาหา D-Time ได้
      };

      // สร้าง URL parameters
      const params = new URLSearchParams();
      Object.entries(dTimeData).forEach(([key, value]) => {
        if (value) {
          params.set(key, encodeURIComponent(value));
        }
      });

      // เปิด Chat ใน tab ใหม่หรือ popup
      // const chatUrl = `https://chat-dev.dcm.co.th?${params.toString()}`; // Fixed the backticks
      const chatUrl = `http://localhost:3000?${params.toString()}`; // Fixed the backticks
      window.open(chatUrl, "chat", "width=1200,height=800");
    },
  },
};
</script>

<style scoped>
.v-speed-dial--bottom {
  bottom: 5px;
}

/* ================= Header bar ================= */
.hd-bar {
  padding: 0 20px;
}

.hd-bar>>>.v-toolbar__content {
  padding: 0 12px;
}

.hd-greeting-wrap {
  min-width: 0;
}

.hd-greeting {
  font-size: 30px;
  font-weight: 700;
  line-height: 1.2;
  color: #111827;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hd-name {
  color: #3E87BE;
}

.hd-subdate {
  color: #6B7280;
  font-size: 14px;
  margin-top: 2px;
}

.hd-right {
  display: flex;
  align-items: center;
}

.hd-time {
  color: #6B7280;
  font-size: 14px;
  margin-right: 20px;
  white-space: nowrap;
}

.hd-time b {
  color: #111827;
  margin-left: 4px;
}

.hd-user {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 4px 6px;
  border-radius: 8px;
  transition: background-color 0.2s ease;
}

.hd-user:hover {
  background-color: #EAF0F6;
}

.hd-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hd-divider {
  width: 1px;
  height: 32px;
  background: #E5E7EB;
  margin: 0 14px;
}

.hd-user-text {
  text-align: right;
  line-height: 1.3;
  max-width: 220px;
}

.hd-user-name {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hd-user-dept {
  font-size: 13px;
  color: #3E87BE;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

@media (max-width: 960px) {
  .hd-greeting {
    font-size: 22px;
  }
}
</style>